var UsedGauge = /** @class */ (function () {
    function UsedGauge(props) {
        Object.assign(this, props);
        if (props.last_at) {
            this.last_at = new Date(props.last_at);
        }
    }
    return UsedGauge;
}());
export default UsedGauge;



//////////////////
// WEBPACK FOOTER
// ./src/modules/UsedGauges/UsedGauge.ts
// module id = 734
// module chunks = 0